// Module
var code = "<section> <div class=\"day-block\" ng-repeat=\"day in $ctrl.days\"> <cr-calendar-all-day-event data=\"event\" ng-repeat=\"event in day.events\"></cr-calendar-all-day-event> </div> </section> ";
// Exports
export default code;